var render, staticRenderFns
import script from "./AiSyntaxMixin.vue?vue&type=script&lang=ts&"
export * from "./AiSyntaxMixin.vue?vue&type=script&lang=ts&"
import style0 from "./AiSyntaxMixin.vue?vue&type=style&index=0&id=5c75dc3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c75dc3b",
  null
  
)

export default component.exports